/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeUpdate
 */
export interface TapeUpdate {
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof TapeUpdate
     */
    generation?: number;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    customA?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    customB?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    customC?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    customD?: string;
    /**
     * 
     * @type {number}
     * @memberof TapeUpdate
     */
    freeSpace?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TapeUpdate
     */
    loadCounter?: number;
    /**
     * 
     * @type {number}
     * @memberof TapeUpdate
     */
    errorCounter?: number;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    errorReason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TapeUpdate
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TapeUpdate
     */
    lto?: TapeUpdateLtoEnum;
    /**
     * 
     * @type {number}
     * @memberof TapeUpdate
     */
    group?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum TapeUpdateLtoEnum {
    _5 = '5',
    _6 = '6',
    _7 = '7'
}

export function TapeUpdateFromJSON(json: any): TapeUpdate {
    return TapeUpdateFromJSONTyped(json, false);
}

export function TapeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'generation': !exists(json, 'generation') ? undefined : json['generation'],
        'customA': !exists(json, 'custom_a') ? undefined : json['custom_a'],
        'customB': !exists(json, 'custom_b') ? undefined : json['custom_b'],
        'customC': !exists(json, 'custom_c') ? undefined : json['custom_c'],
        'customD': !exists(json, 'custom_d') ? undefined : json['custom_d'],
        'freeSpace': !exists(json, 'free_space') ? undefined : json['free_space'],
        'loadCounter': !exists(json, 'load_counter') ? undefined : json['load_counter'],
        'errorCounter': !exists(json, 'error_counter') ? undefined : json['error_counter'],
        'errorReason': !exists(json, 'error_reason') ? undefined : json['error_reason'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'lto': !exists(json, 'lto') ? undefined : json['lto'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function TapeUpdateToJSON(value?: TapeUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'uuid': value.uuid,
        'generation': value.generation,
        'custom_a': value.customA,
        'custom_b': value.customB,
        'custom_c': value.customC,
        'custom_d': value.customD,
        'free_space': value.freeSpace,
        'load_counter': value.loadCounter,
        'error_counter': value.errorCounter,
        'error_reason': value.errorReason,
        'active': value.active,
        'lto': value.lto,
        'group': value.group,
    };
}


